module.exports = __webpack_public_path__ + "static/media/ni.32e4d1fe.svg";